import { useTranslation } from 'react-i18next';

import { motion } from 'motion/react';

import { Container } from '@components/container';
import { Typography } from '@components/typography';
import { MovingBorderContainer } from '@components/ui/moving-border';

import { isMobileDevice } from '@globalUtils/environment';

export function AuditPromoSection() {
  const { t } = useTranslation();

  const CTAButton = () => (
    <div className="flex flex-col items-center gap-2">
      <div className="relative w-[220px]">
        <MovingBorderContainer fullWidth>
          <a
            href="/audit"
            className="w-full mb-0! bg-white no-underline group mb-8 cursor-pointer relative shadow-2xl shadow-zinc-200 rounded-full p-px text-xs font-semibold leading-6 text-white inline-block"
          >
            <span className="absolute inset-0 overflow-hidden rounded-full">
              <span className="absolute inset-0 rounded-full bg-[image:radial-gradient(75%_100%_at_50%_0%,rgba(56,189,248,0.6)_0%,rgba(56,189,248,0)_75%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
            </span>
            <div className="w-full text-white! relative flex space-x-2 items-center z-10 rounded-full bg-black py-0.5 px-4 ring-1 ring-black/10 justify-between">
              <span>{t('auditPromo.cta')}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <motion.path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M10.75 8.75L14.25 12L10.75 15.25"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 1 }}
                ></motion.path>
              </svg>
            </div>
            <span className="absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r from-emerald-400/0 via-emerald-400/90 to-emerald-400/0 transition-opacity duration-500 group-hover:opacity-40"></span>
          </a>
        </MovingBorderContainer>
      </div>
      <Typography variant="caption" className="text-gray-400">
        {t('auditPromo.subtext')}
      </Typography>
    </div>
  );

  return (
    <div className="w-full bg-[#fafafa] py-[7vh] lg:py-[12vh] flex justify-center mt-[10vh]">
      <Container className="lg:w-[80vw]">
        <div className="w-full flex flex-col items-center gap-[5vh] lg:gap-[10vh]">
          <div className="flex w-full flex-wrap lg:flex-nowrap justify-between items-center gap-4 lg:gap-0">
            {/* Left column: Title + CTA */}
            <div className="w-full lg:w-[56%] shrink-0 flex flex-col items-center lg:items-start">
              <Typography className="w-fit text-center lg:text-left" variant="titlesmall">
                {t('auditPromo.headline')}
              </Typography>
              {!isMobileDevice() && (
                <div className="mt-[3vh] lg:mt-[5vh]">
                  <CTAButton />
                </div>
              )}
            </div>

            {/* Right column: Description */}
            <div className="w-full lg:grow flex flex-col items-center lg:items-start">
              <Typography className="w-full whitespace-pre-line" variant="base">
                {t('auditPromo.body')}
              </Typography>
              {isMobileDevice() && (
                <div className="mt-[6vh] lg:mt-[5vh]">
                  <CTAButton />
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
